import { Toast } from 'vant'
const croods = require('./croods-1.3.3.js')
window.croods = croods

function getLocation() {
  return new Promise((resolve, reject) => {
    croods.customPlugin({
      action: 'ServicePermissionPlugin.getLocation',
      params: { coorType: '', reason: '获取定位信息' },
      success: function(res) {
        resolve(res)
      },
      fail: function(msg) {
        Toast.fail('获取位置信息失败')
      }
    })
  })
}

export default getLocation